import { Flex } from '@/components/base';
import { MainText } from '@/components/Typography';
import useAgentStore from '@/features/Agent/stores';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { EllipsisDiv } from '@/styles/style';
import { AGENT_COLUMNS } from '@/types/filterKeyConst';
import { createOptionsFromValues } from '@/utils/util';

export const useAgentFilterMap = () => {
  const workspaceFieldOptions = useWorkspaceStore(
    (state) => state.workspaceFieldOptions,
  );
  const agentMap = useAgentStore((state) => state.agentMap);

  const fieldOptions: StructuredFieldOptionMap = {
    [AGENT_COLUMNS.ALIAS]: {
      columnKey: AGENT_COLUMNS.ALIAS,
      columnName: 'Name',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'pagination',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return Object.values(agentMap)
            .map((agent) => ({
              columnKey: AGENT_COLUMNS.ALIAS,
              filterKey: agent.alias,
              filterName: agent.name,
              searchValue: `${agent.name} / ${agent.email}`,
              filterOptionNode: (
                <Flex g="6px" a="center">
                  <EllipsisDiv style={{ maxWidth: 100 }}>
                    <MainText>{agent.name}</MainText>
                  </EllipsisDiv>
                  <EllipsisDiv style={{ maxWidth: 150 }}>
                    <MainText dim>{agent.email}</MainText>
                  </EllipsisDiv>
                </Flex>
              ),
            }))
            .filter((item) => {
              if (!searchValue) return true;
              return item.searchValue.toLocaleLowerCase().includes(searchValue);
            });
        },
      },
    },
    [AGENT_COLUMNS.ROLE]: {
      columnKey: AGENT_COLUMNS.ROLE,
      columnName: 'Role',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return createOptionsFromValues(
            AGENT_COLUMNS.ROLE,
            workspaceFieldOptions.role_values,
          ).filter((item) => {
            if (!searchValue) return true;
            return item.filterName.toLocaleLowerCase().includes(searchValue);
          });
        },
      },
    },
    [AGENT_COLUMNS.TEAM]: {
      columnKey: AGENT_COLUMNS.TEAM,
      columnName: 'Team',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return createOptionsFromValues(
            AGENT_COLUMNS.TEAM,
            workspaceFieldOptions.team_values,
          ).filter((item) => {
            if (!searchValue) return true;
            return item.filterName.toLocaleLowerCase().includes(searchValue);
          });
        },
      },
    },
  };

  return fieldOptions;
};
